import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';

/**
 * PaginationFooter - Rodapé de paginação server-side, reaproveitado pelas tabelas
 * de Feedbacks e NPS (mesmo layout usado em CompaniesTable).
 * @param {Object} props
 * @param {Object} props.pagination - { total, page, limit, pages }
 * @param {Function} props.onPageChange
 * @param {string} props.itemLabel - rótulo do que está sendo listado, ex: "feedbacks"
 */
function PaginationFooter({ pagination = { total: 0, page: 1, limit: 20, pages: 1 }, onPageChange, itemLabel = 'itens' }) {
  const { total = 0, page = 1, limit = 20, pages = 1 } = pagination;
  const startItem = total === 0 ? 0 : (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, total);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: 3,
        py: 2,
        borderTop: '1px solid #F0F0F0',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Typography variant="body2" color="text.secondary">
        Mostrando {startItem} a {endItem} de {total} {itemLabel}
      </Typography>

      <Pagination
        count={pages}
        page={page}
        onChange={(_, value) => onPageChange(value)}
        shape="rounded"
        color="primary"
        size="small"
        siblingCount={2}
        boundaryCount={1}
      />
    </Box>
  );
}

export default PaginationFooter;
